import React, { useEffect, useState } from "react";
import Select from "react-select";
import { fetchAllUserEmails } from "./emailApi";

export default function UserMultiSelect({ onChange }) {
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    fetchAllUserEmails()
      .then(res => {
        const mappedOptions = res.data.map(u => ({
          label: `${u.name} (${u.email})`,
          value: u.email,
          userId: u.id
        }));
        setOptions(mappedOptions);
      })
      .catch(err => {
        console.error("Failed to load users", err);
      });
  }, []);

  const handleAddAll = () => {
    setSelectedOptions(options);
    onChange(
      options.map(o => ({
        userId: o.userId,
        email: o.value
      }))
    );
  };

  const handleSelectChange = (selected) => {
    setSelectedOptions(selected || []);
    onChange(
      (selected || []).map(s => ({
        userId: s.userId,
        email: s.value
      }))
    );
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleAddAll}
        style={{ marginBottom: 8, padding: "6px 12px", cursor: "pointer" }}
      >
        Add All
      </button>

      <Select
        isMulti
        options={options}
        value={selectedOptions}
        onChange={handleSelectChange}
        placeholder="Select users..."
      />
    </div>
  );
}
